import styled from "styled-components";
import React from "react";

const LogoStyled = styled.div`
    text-align: center;
    font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
    img{
      max-width: 100px;
    }
    
`;

const Logo = (props: any) => {
    let src = props.data.src === '' ? (process.env.NODE_ENV !== 'production' ? '/images/Image_placeholder_293.jpg' : '/wp-content/plugins/wp-campaigns/admin/partials/dist/images/Image_placeholder_293.jpg') : props.data.src;
    src = src.replace('giladt', 'medialab.jerusalemu.org');
    src = src.replace('localhost', 'medialab.jerusalemu.org');

    return (
        <LogoStyled>
            <img
                alt='a'
                src={src}/>
        </LogoStyled>
    );
};

export default Logo;
